export const isProductionEnv =
  process.env.NEXT_PUBLIC_TALLY_API_URL === "https://api.tally.xyz"

export const isStagingEnv =
  process.env.NEXT_PUBLIC_TALLY_API_URL === "https://api.staging.tally.xyz"
